/* beties v9.11: SEO-/Ratgebertexte (.beties-seo) kundenfreundlich darstellen.
   Der komplette Text bleibt im Seitencode – Google, Bing und KI lesen alles, auch eingeklappte Teile.
   1. Tabellen: Spaltenüberschriften als Beschriftung je Zelle (am Handy als Blöcke untereinander).
   2. „Häufige Fragen“: jede Frage wird eine aufklappbare Zeile (Überschrift bleibt erhalten).
   3. Überall einheitlich (Sammlungen, Themenwelten, Innenkissenwelten): nur der erste Absatz ist sichtbar, der Rest unter „Mehr erfahren“. */
(() => {
  if (window.betiesSeoText) return;
  window.betiesSeoText = true;

  const isBoldOnly = (el) => {
    if (!el || el.tagName !== 'P') return false;
    const text = el.textContent.trim();
    const strong = Array.from(el.querySelectorAll('strong,b')).map((s) => s.textContent).join('').trim();
    return text !== '' && strong === text;
  };

  function labelTables(root) {
    root.querySelectorAll('table').forEach((table) => {
      const heads = Array.from(table.querySelectorAll('thead th')).map((th) => th.textContent.trim());
      if (!heads.length) return;
      table.classList.add('beties-seo__table');
      table.querySelectorAll('tbody tr').forEach((tr) => {
        Array.from(tr.children).forEach((cell, i) => {
          if (heads[i]) cell.setAttribute('data-label', heads[i]);
        });
      });
    });
  }

  function faq(root) {
    Array.from(root.querySelectorAll('h2')).forEach((h2) => {
      if (!/fragen/i.test(h2.textContent)) return;
      let node = h2.nextElementSibling;
      while (node && node.tagName !== 'H2') {
        if (node.tagName !== 'H3') { node = node.nextElementSibling; continue; }
        const details = document.createElement('details');
        details.className = 'beties-faq';
        const summary = document.createElement('summary');
        const answer = document.createElement('div');
        answer.className = 'beties-faq__a';
        node.before(details);
        summary.append(node);
        const icon = document.createElement('span');
        icon.className = 'beties-faq__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14"><path d="M1 7h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path class="beties-faq__v" d="M7 1v12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
        summary.append(icon);
        details.append(summary, answer);
        let next = details.nextElementSibling;
        while (next && !/^H[23]$/.test(next.tagName) && !(isBoldOnly(next) && !next.nextElementSibling)) {
          const after = next.nextElementSibling;
          answer.append(next);
          next = after;
        }
        node = next;
      }
    });
  }

  function collapse(root) {
    const kids = Array.from(root.children);
    if (kids.length < 5) return false;
    const first = kids.find((k) => k.tagName === 'P' && k.textContent.trim() !== '');
    if (!first) return false;
    const rest = kids.slice(kids.indexOf(first) + 1);
    if (!rest.length) return false;
    const hasFaq = Array.from(root.querySelectorAll('h2')).some((h) => /fragen/i.test(h.textContent));
    const details = document.createElement('details');
    details.className = 'beties-seo-more';
    const summary = document.createElement('summary');
    summary.innerHTML = '<span class="beties-seo-more__closed">' + (hasFaq ? 'Mehr erfahren – Ratgeber &amp; häufige Fragen' : 'Mehr erfahren') + ' ▾</span><span class="beties-seo-more__open">Weniger anzeigen ▴</span>';
    const body = document.createElement('div');
    body.className = 'beties-seo-more__body';
    rest.forEach((el) => body.append(el));
    details.append(summary, body);
    first.after(details);
    return true;
  }

  function init() {
    document.querySelectorAll('.beties-seo').forEach((root) => {
      if (root.dataset.betiesSeo) return;
      root.dataset.betiesSeo = '1';
      labelTables(root);
      faq(root);
      if (collapse(root)) root.classList.add('beties-seo--quiet');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();